<template>
  <div>
    <div class="materials">
      <v-category-button v-for='material in materials'
        @click="setLogoFlg(material.id)"
        :key="material.id"
        :type="material.type"
        :active="selectedLogoFlg == material.id"
        :disabled="material.disabled"
      >
        {{material.text}}
      </v-category-button>
    </div>
  </div>
</template>

<script>
import VCategoryButton from '@/components/atoms/CategoryButton'
export default {

  components: {
    VCategoryButton
  },

  data: () => ({
    materials: [
      {id: 1, text: 'あり', type: 'have_logo', disabled: false},
      {id: 2, text: 'なし', type: 'no_logo', disabled: false},
    ]
  }),

  computed: {
    selectedLogoFlg() {
      return this.$store.state.conditions.selectedLogoFlg;
    }
  },

  mounted() {
  },

  methods: {
    setLogoFlg(logoFlg) {
      this.$store.commit('conditions/setSelectedLogoFlg', {
        logoFlg: logoFlg
      })
    }
  },

  watch: {
  }
}
</script>

<style lang="stylus" scoped>
.materials
  max-width 800px

</style>
